import { Suspense } from "react";
import OtpVerifyPage from "@/app/auth/otp/otp";
import AuthSkeleton from "@/components/auth-skeleton";

export default function AuthOtpPage() {
  return (
    <Suspense fallback={<AuthSkeleton />}>
      <OtpVerifyPage />
    </Suspense>
  )
}
